// extracted by mini-css-extract-plugin
export default {"tag":"styles_tag__tS2J8","tag-gray":"styles_tag-gray__6yxT7","tag-green":"styles_tag-green__ZYTwp","tag-red":"styles_tag-red__pHCuh","tag-yellow":"styles_tag-yellow__OrN5b"};